// @flow
import * as React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import PersonAddRoundedIcon from "@material-ui/icons/PersonAddRounded";
import Chip from "@material-ui/core/Chip";
import TicketReservationAddCompanionForm from "./TicketReservationAddCompanionForm";
import { SuspenseWithPerf } from "reactfire";
import Container from "@material-ui/core/Container";
import Skeleton from "@material-ui/lab/Skeleton";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: "relative",
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    skeleton: {
      "& > *": {
        marginBottom: theme.spacing(1),
      },
    },
  })
);

const Transition = React.forwardRef(function Transition(
  props: { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type Props = {
  handleSubmit: Function,
};

function TicketReservationAddCompanionModal({ handleSubmit }: Props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmitAndClose = async (companionId: string) => {
    await handleSubmit(companionId);
    setOpen(false);
  };

  return (
    <>
      <Chip
        color="primary"
        variant="outlined"
        icon={<PersonAddRoundedIcon />}
        label="Weitere hinzufügen"
        clickable
        onClick={handleClickOpen}
      />
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        maxWidth="sm"
      >
        <AppBar className={classes.appBar} color="inherit">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Begleitung hinzufügen
            </Typography>
          </Toolbar>
        </AppBar>
        <Container maxWidth="sm">
          <Box
            mt={3}
            style={{ marginBottom: "calc(env(safe-area-inset-bottom)" }}
          >
            <Box mb={1}>
              <Typography variant="body2" color="textSecondary">
                Ergänze die Kontaktdaten deiner Begleitung. Diese werden
                ausschließlich zur Nachverfolgung von Corona-Infektionsketten
                verwendet.
              </Typography>
            </Box>
            <SuspenseWithPerf
              traceId="TicketReservationAddCompanionForm"
              fallback={
                <div className={classes.skeleton}>
                  <Skeleton width="100%" height={56} />
                  <Skeleton width="100%" height={56} />
                  <Skeleton width="100%" height={56} />
                </div>
              }
            >
              <TicketReservationAddCompanionForm
                handleSubmit={handleSubmitAndClose}
              />
            </SuspenseWithPerf>
          </Box>
        </Container>
      </Dialog>
    </>
  );
}

export default TicketReservationAddCompanionModal;
